import {TFunction} from 'i18next';
import {SECTION_ID_BUILDINGS, constructBuildingFilter} from './buildingFilter';
import {constructFilter} from './constructFilter';
import {SECTION_ID_FLOORS} from './floorFilter';
import {Building, Floor} from '@lib/store';

export const constructBuildingWithFloorsFilter = <TEntity extends {buildingId: string; floorId: string}>(
  buildings: Building[],
  defaultBuildingId: string,
  floors: Floor[],
  t: TFunction,
) => {
  const buildingsFilter = constructBuildingFilter(buildings, defaultBuildingId, t);
  const floorsFilter = constructFilter({
    sectionId: SECTION_ID_FLOORS,
    sectionTitle: t('Floor'),
    type: 'or',
    data: floors.map(({id, name, buildingId}) => ({
      id,
      label: name,
      dynamicFilterConfig: {sectionId: buildingsFilter.sectionId, filterOptionId: buildingId},
    })),
    defaultFilterOptions: [],
    predicate: (filter, entity: TEntity) => entity.floorId === filter.id,
  });

  return {[SECTION_ID_BUILDINGS]: buildingsFilter, [SECTION_ID_FLOORS]: floorsFilter};
};
